import React from 'react';
import styled from 'styled-components';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

function ApplicationSpinner() {
  return (
    <Container>
      <FontAwesomeIcon icon={faSpinner} size="6x" spin />
    </Container>
  );
}

export default ApplicationSpinner;
